import React from "react";
import "../styles/playerStats.css";

const PlayerStats = () => {
  return (
    <div id="playerStats">
      <h1>EVERSON F. MACHADO</h1>
      <h2>LEVEL 30</h2>
      <div id="playerStats__lines">
        <span id="playerStats__lines__thick"></span>
        <span id="playerStats__lines__thin"></span>
      </div>
      <h2>FrontEnd/Mobile Developer</h2>
    </div>
  );
};

export default PlayerStats;
